import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {
  _checkTokens,
  _checkErrors,
  _tryOrRefresh,
  I_COMMON_GET_ALL_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
} from './_base';

import I_CHARGES,{I_CHARGE} from '../interfaces/I_CHARGES';
import {
  getActivitiesResponse,
  postActivityResponse,
  deleteActivityResponse,
  getActivityResponse,
  putActivityResponse,
  exportActivitiesResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- ACTIVITIES
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge

  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
}
interface I_EXPORT_PARAMS extends I_GET_PARAMS {
  file_type: string;  // csv ou  xls
  file_format: string;
}
interface I_ACTIVITY_FIELDS {
  model?: boolean;
  id_model?: number;  // uniquement si model = true

  name: string;
  description?: string;

  collaborator_id: number | null; // FK Collaborateur
  skills_id: number[]; //FK compétences il peut y en avoir plusieurs
  mode_volume: 'hour' | 'percent' | '';  // definit la facon dont on rentre les heures (hour | percent)
  value_volume?: number; // valeur pour heures (!! peut etre null poour la creation d'un model)
  /** id du type d'activité de l'activité (opt.) */
  activity_type_id?: number;

  from_date?: string;  //obligatoire si model==false
  to_date?: string;  //obligatoire si model==false
  direction?: string;  //obligatoire si model==false
  hub?: string; // sous-direction (pole)
  site_customer_id?: number;  // site d'intervention, parrmi les sites créés pour le referential customer de la charge
  audit_date?: string;
  audit_start_date?: string;
  audit_end_date?: string;
  funct: string;
  provisional?: boolean;
}
interface I_CREATE_ACTIVITY_PARAMS extends I_COMMON_CREATE_PARAMS, I_ACTIVITY_FIELDS {}
interface I_PUT_ACTIVITY_PARAMS extends I_COMMON_PUT_PARAMS, I_ACTIVITY_FIELDS {}


// ----

const isMissingField = (activity:I_ACTIVITY_FIELDS) => {

  const nameKO = !activity.name || activity.name === null || activity.name.trim() === '';

  if (!activity.model) {
    const fromdateKO = !activity.from_date || activity.from_date === null || activity.from_date.trim() === '';
    const todateKO = !activity.to_date || activity.to_date === null || activity.to_date.trim() === '';
    const volumeKO = activity.value_volume === undefined || activity.value_volume === null || activity.value_volume <= 0;
    if (nameKO || volumeKO || fromdateKO || todateKO) {
      logger.debug('Missing fields for activity :',{nameKO,fromdateKO,todateKO,volumeKO})
    }
    return nameKO || volumeKO || fromdateKO || todateKO;
  }
  else {
    const idmodelKO = !activity.id_model || activity.id_model === null;
    return nameKO || idmodelKO;
  }

}





/**
 * Récupère la liste des activites
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,dispatch,state,
  page,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
}:I_GET_PARAMS):Promise<I_CHARGES> => {
  logger.debug('ApiServices - activities - getList...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getActivitiesResponse({
        accessToken:usedAccessToken,page,
        from_date,to_date,activity_types,directions_ops,hubs_ops,directions_hr,hubs_hr,collaborators,
        skills,functions,billing_customers,
        audited_customers,
        referentials,
        referential_types,
        of_number,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - getList - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGES = await response.json();
  logger.debug('ApiServices - activities - getList - ok, returned body',body);
  return body;
};

/**
 * Crée une activite
 * @param param0
 * @returns
 */
const create = async (args:I_CREATE_ACTIVITY_PARAMS):Promise<string> => {
  logger.debug('ApiServices - activities - create...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    model,id_model,
    name,description,
    direction,hub,
    from_date,to_date,
    collaborator_id,
    skills_id,
    mode_volume,
    value_volume,
    site_customer_id,
    audit_date,
    audit_start_date,
    audit_end_date,
    funct,
    provisional,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post new charge',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postActivityResponse({
        accessToken:usedAccessToken,
        model,id_model,
        name,description,
        direction,hub,
        from_date,to_date,
        collaborator_id,
        skills_id,
        mode_volume,
        value_volume,
        site_customer_id,
        audit_date,
        audit_start_date,
        audit_end_date,
        funct,
        provisional,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - create - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - activities - create - ok, returned body',body);
  logger.info(...formatInfo('Activity created!'));
  return body;
};

/**
 * Supprime une activite
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - activities - remove...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteActivityResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - remove - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - activities - remove - ok, returned body',body);
  logger.info(...formatInfo('Activity deleted!'));
  return body;
};


/**
 * Modifie une activite
 * @param param0
 * @returns
 */
const update = async (args:I_PUT_ACTIVITY_PARAMS):Promise<string> => {
  logger.debug('ApiServices - activities - update...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    id,
    name,description,
    direction,hub,
    from_date,to_date,
    collaborator_id,
    skills_id,
    mode_volume,
    value_volume,
    site_customer_id,
    audit_date,
    audit_start_date,
    audit_end_date,
    funct,
    provisional,
    activity_type_id,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post new charge',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putActivityResponse({
        accessToken:usedAccessToken,
        id,
        name,description,
        direction,hub,
        from_date,to_date,
        collaborator_id,
        skills_id,
        mode_volume,
        value_volume,
        site_customer_id,
        audit_date,
        audit_start_date,
        audit_end_date,
        funct,
        provisional,
        activity_type_id,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - update - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - activities - update - ok, returned body',body);
  logger.info(...formatInfo('Activity updated!'));
  return body;
};

/**
 * Récupère l'activite
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.debug('ApiServices - activities - getItem...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getActivityResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - getItem - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGE = await response.json();
  logger.debug('ApiServices - activities - getItem - ok, returned body',body);
  return body;
};


/**
 * Récupère la liste des activites
 * @param obj
 * @returns
 */
const exportList = async ({
  accessToken,refreshToken,dispatch,state,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  file_type,
  file_format,
}:I_EXPORT_PARAMS):Promise<string|Blob> => {
  logger.debug('ApiServices - activities - exportList...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return exportActivitiesResponse({
        accessToken:usedAccessToken,
        from_date,to_date,activity_types,directions_ops,hubs_ops,directions_hr,hubs_hr,collaborators,
        skills,functions,billing_customers,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        file_type,
        file_format,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - activities - exportList - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  logger.trace(...formatTrace('ApiServices - activities - exportList - file_type=',file_type));
  if (file_type === 'xlsx') {
    const body:Blob = await response.blob();
    logger.debug('ApiServices - activities - exportList - ok, returned body',body);
    return body;
  }
  const body:string = await response.text();
  logger.debug('ApiServices - activities - exportList - ok, returned body',body);
  return body;
};

const activitiesServices = {
  getList,
  create,
  remove,
  update,
  getItem,
  exportList,
};

export default activitiesServices;
